import React from 'react';
import { locale } from '@tcc/i18n';
import { Button, ButtonWidth, ComponentSize, FdsIcon, Icon } from '@tcc/fds';
import { useFormContext } from 'react-hook-form';
import { useAppSelector } from 'app/hooks';
import { inferUnit } from 'util/unitConversion';
import { printElement } from 'util/print';
import { getCurrency } from 'user/userSelectors';
import { SEASONS_ACRONYMS } from 'constants/seasons';
import { currencyFormatter, getMessage } from 'util/locale';
import { formatDateToLocale } from 'util/formatters/dateFormatter';
import { REVIEW_AND_DOWNLOAD_CLASS_NAME } from '../../common/constants';
import { InfoItem } from './InfoItem';
import { FieldsList } from './FieldsList';

const baseString = REVIEW_AND_DOWNLOAD_CLASS_NAME;

export function ReviewAndDownload() {
  const { getValues } = useFormContext();
  const [grainPrice, plannedPlantingDate, season] = getValues(['grainPrice', 'plannedPlantingDate', 'season']);
  const currency = useAppSelector(getCurrency);

  return (
    <div className={baseString}>
      <div className={`${baseString}__header`}>
        <div className={`${baseString}__header-content`}>
          <div className={`${baseString}__header-heading`}>
            <div className={`${baseString}__badge-icon`}>
              <Icon icon={FdsIcon.Info} size={ComponentSize.Lg} />
            </div>
            <div className={`${baseString}__header-titles`}>
              <h2 className={`${baseString}__header-title`}>{getMessage('text__field-level-seed-recs')}</h2>
              <p className={`${baseString}__header-subtitle`}>{getMessage('text__fieldview-seed-scripts')}</p>
            </div>
          </div>
          <div className={`${baseString}__header-actions`}>
            <Button
              testId="print-button"
              size={ComponentSize.Md}
              width={ButtonWidth.FitContent}
              onClick={() => printElement({ className: baseString })}
            >
              <Icon icon={FdsIcon.Print} />
              {getMessage('button-print')}
            </Button>
            {/* TODO: Remove the comment when Download functionality is available */}
            {/* <Button testId='download-button' size={ComponentSize.Md} onClick={handleDownload} width={ButtonWidth.FitContent}>
            <Icon icon={FdsIcon.Download} />
            {getMessage('button-text__export--download')}
          </Button> */}
          </div>
        </div>
        <div className={`${baseString}__info`}>
          <InfoItem
            label={`${getMessage('title-text__planting-date')}:`}
            value={formatDateToLocale(plannedPlantingDate, locale)}
          />
          <InfoItem
            label={`${getMessage('title-text__date-generated')}:`}
            value={formatDateToLocale(new Date(), locale)}
          />
          <InfoItem
            label={`${getMessage('bulk-fvss-review-scripts-grain-price-label', {
              unit: inferUnit('mass.yield').label.universal,
            })}:`}
            value={currencyFormatter(grainPrice, currency, { round: false })}
          />
          {season && (
            <InfoItem
              label={getMessage('label-text__season')}
              value={getMessage(`season__${SEASONS_ACRONYMS[season]}`)}
            />
          )}
        </div>
      </div>
      <FieldsList />
    </div>
  );
}
